/**
 * Revoga liberação: PATCH status=cancelled (+ statusChanged=now).
 * @module CancelMedicationDispense
 */

import dayjs from "dayjs";
import { PatchEHRPoster } from "../PatchEHRPoster";

/**
 * Cancela um MedicationDispense persistido.
 * statusChanged faz sentido aqui (mudança de status), não para validade.
 */
export async function CancelMedicationDispense(
  medicationDispenseId: string,
): Promise<void> {
  const id = medicationDispenseId?.trim();
  if (!id) {
    throw new Error("Liberação não identificada para revogar.");
  }

  await PatchEHRPoster({
    resourceType: "MedicationDispense",
    resourceId: id,
    operation: "replace",
    path: "/status",
    value: "cancelled",
  });

  // Melhor esforço: statusChanged = agora (alguns servidores exigem add)
  try {
    await PatchEHRPoster({
      resourceType: "MedicationDispense",
      resourceId: id,
      operation: "add",
      path: "/statusChanged",
      value: dayjs().toISOString(),
    });
  } catch {
    try {
      await PatchEHRPoster({
        resourceType: "MedicationDispense",
        resourceId: id,
        operation: "replace",
        path: "/statusChanged",
        value: dayjs().toISOString(),
      });
    } catch {
      // status já cancelado — statusChanged é complementar
    }
  }
}
